import { Component, OnInit } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-providermaintenance-dialog',
  templateUrl: './providermaintenance-dialog.component.html',
  styleUrls: ['./providermaintenance-dialog.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})

export class ProvidermaintenanceDialogComponent implements OnInit {
  public show: boolean = false;

  showInfo() {
    // this.popupVisible = true;
    this.show = !this.show;
  }


  provmaincomponentform: FormGroup;
  submitted = false;


  constructor(private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.provmaincomponentform = this.formBuilder.group({

      payerid: ['',],
      idtype: ['',],
      popid: ['',],
      taxo: ['',],

    });
  }

  get f() { return this.provmaincomponentform.controls; }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.provmaincomponentform.invalid) {
      return;
    }


  }

  onNoClick() { }

}


